// extracted by mini-css-extract-plugin
export default {"table":"ListingDetails_table__8+shp","listingDetailsContainer":"ListingDetails_listingDetailsContainer__8nnrG","listingLoader":"ListingDetails_listingLoader__pf0UZ"};